//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Diagramming.js";
import "../Diagramming/Diagramming.BaseSubObjectBuilder.js";
let d=[[[0,"EvaluatedValueX",0,0],[0,"EvaluatedValueY",0,0],[0,"InputPercentX",1,0],[0,"InputPercentY",1,0],[0,"InputValueX",1,0],[0,"InputValueY",1,0],[0,"Reference",1,"Diagramming.SheetElement",0],[0,"UpToDate",0,0]],[[["inputPercent","inputValue"],"SetValueX",{},2,0],[["inputPercent","inputValue"],"SetValueY",{},2,0]],[]];
SPLM.Diagramming.LocationBuilder = class extends SPLM.Diagramming.BaseSubObjectBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Diagramming.LocationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;